module.exports = __webpack_public_path__ + "static/media/06n.f642dac5.svg";